import { render, staticRenderFns } from "./selfDriverTeamForm.vue?vue&type=template&id=70922b96"
import script from "./selfDriverTeamForm.vue?vue&type=script&lang=js"
export * from "./selfDriverTeamForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports